const education = {
  title: "Education",
  image: "/images/cit.png",
  items: [
    {
      institute: "Chennai Institute Of Technology",
      degree: "B.Tech Information Technology",
      score: "CGPA - 8.9"
    }
  ]
}

export default education;